import { render, staticRenderFns } from "./IdIssuers.vue?vue&type=template&id=864d09ca&scoped=true&"
import script from "./IdIssuers.vue?vue&type=script&lang=js&"
export * from "./IdIssuers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d09ca",
  null
  
)

export default component.exports